import { createContext } from 'react';

export interface TabContextProps {
  active: Boolean;
}

export const TabContext = createContext<TabContextProps>({ active: false });
